/**
 * Colonization: IPM's biggest crafting sink (GDD §3.7). Spend crafted items
 * on a planet for a permanent-this-run multiplier on that planet. Colony
 * levels reset on Fold, like IPM's colonies reset on a galaxy sell.
 */

import { ITEMS, type Ingredient } from './resources';

export const COLONY_MAX_LEVEL = 10;
/** Planet mining per colony level. */
export const COLONY_MINE_PER_LEVEL = 0.25;
/** Planet ship speed and cargo per colony level. */
export const COLONY_HAUL_PER_LEVEL = 0.1;

const COMMONS = ITEMS.filter((d) => d.rarity === 'common');
const RARES = ITEMS.filter((d) => d.rarity === 'rare');

/**
 * Items for colony level `level + 1` on planet `planet`. Early levels ask for
 * Commons matched to the planet's depth; from level 6, a Rare as well.
 */
export function colonyCost(planet: number, level: number): Ingredient[] {
  if (level >= COLONY_MAX_LEVEL) return [];
  const common = COMMONS[Math.min(COMMONS.length - 1, Math.floor(planet * 0.9) + Math.floor(level / 2))]!;
  const out: Ingredient[] = [{ id: common.id, qty: 2 + level * 2 }];
  if (level >= 5) {
    const rare = RARES[Math.min(RARES.length - 1, Math.floor(planet * 0.8) + (level - 5))]!;
    out.push({ id: rare.id, qty: level - 4 });
  }
  return out;
}
